import { render, staticRenderFns } from "./FreeUse.vue?vue&type=template&id=181d5e56&scoped=true&"
import script from "./FreeUse.vue?vue&type=script&lang=js&"
export * from "./FreeUse.vue?vue&type=script&lang=js&"
import style0 from "./FreeUse.vue?vue&type=style&index=0&id=181d5e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d5e56",
  null
  
)

export default component.exports